<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: 100vh">
        <v-container fluid>
          <v-row>
            <v-col cols="2">
              <v-card :to="'/suppliers'">
                <v-card-text class="text-center p-8">
                  <v-icon :icon="'$mdiFolder'" size="x-large"></v-icon>
                  <div class="text-h3 font-weight-bold">2</div>
                  <p class="font-weight-thin">поставщика(ов)</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card>
                <v-card-text class="text-center">товаров</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const AccountRepository = RepositoryFactory.get("accountRepository");
export default {
  components: {
    Navigation,
  },
  mounted() {
    this.userInfo();
  },
  methods: {
    async userInfo() {
      AccountRepository.userInfo();
    },
  },
};
</script>
